import React from 'react';
import Select from 'react-select';
import countries from '../../data/countries.json';

// Static ISO 3166-1 snapshot from the system iso-codes dataset, 2026-09-18.
// Keep names in the existing address API; codes identify options, not eligibility.
const options = [
  ...countries.filter(country => country.code === 'ZA'),
  ...countries.filter(country => country.code !== 'ZA')
].map(country => ({ value: country.name, label: country.name, code: country.code }));

type Props = {
  id: string;
  value?: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  invalid?: boolean;
};

export default function CountrySelect({ id, value, onChange, onBlur, invalid }: Props) {
  const key = value?.trim().toLowerCase();
  const selected = options.find(option => option.value.toLowerCase() === key || option.code.toLowerCase() === key);
  // Retain legacy values without silently rewriting a returning customer's data.
  const current = selected || (value ? { value, label: value, code: '' } : null);
  return <Select
    inputId={id}
    instanceId={id}
    options={options}
    value={current}
    onChange={option => onChange(option?.value || '')}
    onBlur={onBlur}
    isSearchable
    isClearable
    aria-invalid={invalid}
    placeholder="Search for a country…"
    noOptionsMessage={() => 'No matching country'}
    filterOption={({ data }, input) => `${data.label} ${data.code}`.toLowerCase().includes(input.trim().toLowerCase())}
    styles={{ control: (base, state) => ({ ...base, minHeight: 38, borderColor: invalid ? '#dc3545' : state.isFocused ? '#198754' : base.borderColor }) }}
  />;
}
